'use strict';

/**
 * @module MapBookeeAreaView
 * @author Philip & Micha
 */

const DataHelper = require('../helpers/data');
const ConfigurationHelper = require('../helpers/configuration');

class MapBookeeAreaView {
	constructor (map) {
		this.map = map;
		this.areas = [];
		this.polygons = [];
		
		(async () => {
			this.areas = await DataHelper.request('getBookeeAreas');
			
			if (this.areas.length > 0) {
				this.render();
			}
		})();
	}
	
	render () {
		this.areas.forEach((area, i) => {
			let nextArea = this.areas.length > (i + 1) ? this.areas[i + 1] : null;
			if (nextArea !== null) {
				nextArea = nextArea.includePolygons;
			}

			this.renderBookeeArea(area, nextArea || []);
		});
	}
	
	renderBookeeArea (model, nextPolygons) {
		const includePolygons = model.includePolygons || [];
		const excludePolygons = model.excludePolygons || [];

		includePolygons.forEach(included => {
			if (!included.points || !included.points.length) {
				return;
			}

			const paths = [];

			// included
			paths.push(included.points.map(point => new google.maps.LatLng(point.latitude, point.longitude)));

			// excluded
			excludePolygons.forEach(excluded => {
				paths.push(excluded.points.map(point => new google.maps.LatLng(point.latitude, point.longitude)).reverse());
			});

			// next
			nextPolygons.forEach(next => {
				paths.push(next.points.map(point => new google.maps.LatLng(point.latitude, point.longitude)).reverse());
			});
			
			
			const polyColor = ConfigurationHelper.getPolygonColor() || included.color;
			const polygon = new google.maps.Polygon({
				paths,
				clickable: false,
				strokeColor: polyColor,
				strokeOpacity: 1,
				strokeWeight: 2,
				fillColor: included.color || '#000000',
				fillOpacity: 0, //0.05,
				// map: this.map,
				hiddenByLegend: false,
				zIndex: 0
			});

			// polygon.addListener('mouseover', () => {
			// 	polygon.setOptions({fillOpacity: 0.2});
			// });
			// polygon.addListener('mouseout', () => {
			// 	polygon.setOptions({fillOpacity: 0.05});
			// });

			this.polygons.push(polygon);
		});
	}
	
	show () {
		(this.polygons || []).forEach(polygon => {
			polygon.setMap(this.map);
		});

		return this;
	}
	
	hide () {
		(this.polygons || []).forEach(polygon => {
			polygon.setMap(null);
		});

		return this;
	}
}

module.exports = MapBookeeAreaView;
